import type {ViewableFile} from 'typings/portaro.be.types';
import type {FileDataService} from '../../features/file/file.data-service';
import type {FileViewForm} from 'shared/constants/portaro.constants';

export class FilesSelectionModalService {
    public static serviceName = 'filesSelectionModalService'

    /*@ngInject*/
    constructor(private fileDataService: FileDataService) {
    }

    public async getAllFiles(parentDirectoryIds: number[], fileViewForms?: FileViewForm[]): Promise<ViewableFile[]> {
        return this.fileDataService.queryFiles({
            rootDirectory: parentDirectoryIds,
            fileViewForm: fileViewForms
        });
    }
}